import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { HasPermission } from '../../authorization/components/HasPermission';
import { AppPermissions } from '../../authorization/Permissions';
import { ScriptManagementStores } from '../stores';
import { STORE_SCRIPT_MANAGEMENT } from '../stores/constants';
import { IotaAppStores } from '../../iota_applications/stores';
import CreateEditScript from '../components/CreateEditScript';

type CombinedStores = ScriptManagementStores & IotaAppStores;

const CreateEditScriptScreen: React.FC<CombinedStores> = ({ scriptManagementUI: store }) => {
    return (
        <HasPermission permissionClaim={AppPermissions.CanManageScripts}>
            <CreateEditScript store={store!} />
        </HasPermission>
    );
};

export default inject(STORE_SCRIPT_MANAGEMENT)(observer(CreateEditScriptScreen));
